<!--
  time:2024/01/03
  component：列表中排序

  此时供多级表头的排序使用，需要与headerRender配合使用
  单级表头无需使用该组件直接声明sortable=true即可
  sortText:排序文字
  sortName:排序字段
  sortBy:排序列表（必传）

  回调：
  ascending(sortArray)：升序
  cancelAscending(sortArray)：取消升序
  descending(sortArray)：降序
  cancelDescending(sortArray)：取消降序
-->
<template>
  <div class="tableSort pointer">
    <span @click="clickSort">{{ sortText }}</span>
    <i ref="ascending" class="tableSort-top" @click="ascending"></i>
    <i ref="descending" class="tableSort-bottom" @click="descending"></i>
  </div>
</template>

<script>
export default {
  name: "tableSort",
  props: {
    sortText: {
      type: String,
      default: "",
    },
    sortName: {
      type: String,
      default: "",
    },
    sortBy: {
      default() {
        return [];
      },
    },
    treeListName: {
      type: String,
      default: "treeList",
    },
    eventName: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      ascendingType: false,
      descendingType: false,
      sortArray: [],
      sortType: 2, //0:升序1：降序2：无排序
      targetParent: null,
    };
  },
  methods: {
    ascending() {
      //升序
      this.$refs["descending"].style.borderTopColor = "#C0C4CC";
      if (this.ascendingType) {
        this.ascendingType = false;
        this.$refs["ascending"].style.borderBottomColor = "#C0C4CC";
        let sortIndex = null;
        this.sortArray.map((item, index) => {
          if (item.fieldName === this.sortName) {
            sortIndex = index;
          }
        });
        this.sortArray.splice(sortIndex, 1);
        this.sortType = 2;
        this.$emit("cancelAscending", this.sortArray);
        // this.$emit("changeTableSort");
        this.changeDefaultStyle();
        return;
      }
      this.ascendingType = true;
      this.descendingType = false;
      this.$refs["ascending"].style.borderBottomColor = "#cd0100";
      let sortIndex = null;
      this.sortArray.map((item, index) => {
        if (item.fieldName === this.sortName) {
          sortIndex = index;
        }
      });
      if (sortIndex != null) {
        this.sortArray.splice(sortIndex, 1);
      }
      this.sortArray.push({
        fieldName: this.sortName,
        orderByType: 0,
      });
      this.sortType = 0;
      this.$emit("ascending", this.sortArray);
      // this.$emit("changeTableSort");
      this.changeDefaultStyle();
    },
    descending() {
      //降序
      this.$refs["ascending"].style.borderBottomColor = "#C0C4CC";
      if (this.descendingType) {
        this.descendingType = false;
        this.$refs["descending"].style.borderTopColor = "#C0C4CC";
        let sortIndex = null;
        this.sortArray.map((item, index) => {
          if (item.fieldName === this.sortName) {
            sortIndex = index;
          }
        });
        this.sortArray.splice(sortIndex, 1);
        this.sortType = 2;
        this.$emit("cancelDescending", this.sortArray);
        // this.$emit("changeTableSort");
        this.changeDefaultStyle();
        return;
      }
      this.descendingType = true;
      this.ascendingType = false;
      this.$refs["descending"].style.borderTopColor = "#cd0100";
      let sortIndex = null;
      this.sortArray.map((item, index) => {
        if (item.fieldName === this.sortName) {
          sortIndex = index;
        }
      });
      if (sortIndex != null) {
        this.sortArray.splice(sortIndex, 1);
      }
      this.sortArray.push({
        fieldName: this.sortName,
        orderByType: 1,
      });
      this.sortType = 1;
      this.$emit("descending", this.sortArray);
      // this.$emit("changeTableSort");
      this.changeDefaultStyle();
    },
    noSort() {
      //无排序
      this.$refs["ascending"].style.borderBottomColor = "#C0C4CC";
      this.$refs["descending"].style.borderTopColor = "#C0C4CC";
      let sortIndex = null;
      this.sortArray.map((item, index) => {
        if (item.fieldName === this.sortName) {
          sortIndex = index;
        }
      });
      this.sortArray.splice(sortIndex, 1);
      // this.$emit("changeTableSort");
      this.changeDefaultStyle();
    },
    clickSort() {
      //自动排序
      if (this.sortType === 2) {
        this.sortType = 0;
        this.ascending();
      } else if (this.sortType === 0) {
        this.sortType = 1;
        this.descending();
      } else if (this.sortType === 1) {
        this.sortType = 2;
        this.noSort();
      }
    },
    // 查找包含 treeList 的父组件
    findParentWithTreeList() {
      let parent = this.$parent;
      while (parent) {
        // 检查父组件的name是否为treeList
        if (parent.$options.name == this.treeListName) {
          return parent.$parent;
        }
        parent = parent.$parent;
      }
      return null;
    },
    // 处理默认样式
    handleDefaultStyle(val) {
      this.sortArray = val;
      let temp = val.find((item) => item.fieldName === this.sortName);
      if (temp && this.$refs["ascending"] && this.$refs["descending"]) {
        if (temp.orderByType === 1) {
          this.$refs["ascending"].style.borderBottomColor = "#C0C4CC";
          this.descendingType = true;
          this.ascendingType = false;
          this.$refs["descending"].style.borderTopColor = "#cd0100";
          this.sortType = 1;
        } else if (temp.orderByType === 0) {
          this.$refs["descending"].style.borderTopColor = "#C0C4CC";
          this.ascendingType = true;
          this.descendingType = false;
          this.$refs["ascending"].style.borderBottomColor = "#cd0100";
          this.sortType = 0;
        }
      }
    },
    // 存储默认样式
    changeDefaultStyle() {
      if (!this.targetParent || !this.targetParent.modifyTableSortBy) return;
      this.targetParent.modifyTableSortBy(this.sortArray);
    },
  },
  created() {
    this.sortArray = this.sortBy;
  },
  async mounted() {
    const targetParent = this.findParentWithTreeList();
    if (targetParent) {
      this.targetParent = targetParent;
      const parentName = targetParent.$options.name;
      const eventName =
        this.eventName ||
        localStorage.getItem("server") + parentName + "TableSort";
        console.log(eventName);

      this.$eventBus.$on(eventName, (val) => {
        this.$nextTick(() => {
          this.handleDefaultStyle(val);
        });
      });
    }
  },
};
</script>

<style lang="scss">
.tableSort {
  text-align: left;
  i {
    position: absolute;
    font-size: 14px;
    line-height: 8px;
    height: 0px;
    width: 0px;
    margin-left: 3px;
  }
  &-top {
    color: #c0c4cc;
    border: solid 5px transparent;
    border-bottom-color: #c0c4cc;
    margin-top: -3px;
  }
  &-bottom {
    color: #c0c4cc;
    border: solid 5px transparent;
    border-top-color: #c0c4cc;
    margin-top: 9px;
  }
}
</style>
